import { Controller } from 'stimulus';
import { FetchRequest } from '@rails/request.js';
import { templateContent } from '@/js/util';
import { modalContainer, openModal } from '@/js/modules/turbo-modal';

const MODAL_SELECTOR = '[data-controller~="ui--turbo-modal"]';

export default class extends Controller {
  static targets = ['selectedImageContainer', 'previewTemplate'];
  static values = { imagesPath: String, updatePath: String };

  #preview;

  openPicker(event) {
    event.preventDefault();

    if (modalContainer().querySelector(MODAL_SELECTOR)) {
      return;
    }

    openModal(this.imagesPathValue).catch(console.error);
  }

  openPreview(event) {
    event.preventDefault();

    if (this.#preview?.isConnected) {
      return;
    }

    this.#preview = templateContent(this.previewTemplateTarget);
    modalContainer().append(this.#preview);
  }

  async removeImage(event) {
    event.preventDefault();

    await this.#updateImage();
  }

  #updateImage(imageableId, imageableType) {
    const body = new FormData();

    if (imageableId) {
      body.append('imageable_id', imageableId);
      body.append('imageable_type', imageableType);
    }

    const request = new FetchRequest('post', this.updatePathValue, {
      body,
      responseKind: 'turbo-stream',
    });

    return request
      .perform()
      .then((response) => {
        if (!response.ok) {
          console.error(`Failed to update the spec sheet image: ${response.statusCode}`);
        }

        return response.ok;
      })
      .catch((error) => {
        console.error(error);
        return false;
      });
  }
}
